import { CoreEvent } from '@carvana/core-events';
import type { Handler } from 'mitt';

export interface VerifxBlockingEvents {
  VERIFX_NAVIGATION_BLOCK_CHANGED: { shouldBlock: boolean };
}

export interface VerifxModalEvents {
  VERIFX_OPEN_CANCEL_ORDER_MODAL: Record<string, never>;
  VERIFX_OPEN_EDIT_ORDER_MODAL: {
    editingSectionName?: string;
    targetStep?: string;
  };
}

export const VERIFX_NAVIGATION_BLOCK_CHANGED = 'VERIFX_NAVIGATION_BLOCK_CHANGED';
export const VERIFX_OPEN_CANCEL_ORDER_MODAL = 'VERIFX_OPEN_CANCEL_ORDER_MODAL';
export const VERIFX_OPEN_EDIT_ORDER_MODAL = 'VERIFX_OPEN_EDIT_ORDER_MODAL';

// CoreEvent exposes onWithType/emitWithType but not offWithType; centralize the cast.
export function coreEventOffWithType<T, Key extends keyof T>(
  type: Key,
  handler: Handler<T[Key]>
): void {
  // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-unsafe-member-access
  (CoreEvent.off as Function)(type, handler);
}
